import type { CSSProperties } from 'react';
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const list = css`
  list-style: none;
  margin: ${spacing.md}px 0;
  padding: 0;
`;

export interface NavigationDrilldownButtonCSSProperties extends CSSProperties {
  '--color': string;
}

const fontStyles = css`
  ${theme.responsiveText.BODY.MD}
  color: var(--color, var(--neutral-black-base));
`;

export const button = css`
  ${fontStyles}
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: ${spacing.md}px;
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: var(--brand-purple-30);
  }
`;

export const link = css`
  ${fontStyles}
  text-decoration: none;
  box-sizing: border-box;
`;

export const seeAllLink = css`
  ${fontStyles};
  background-color: var(--brand-purple-base);
  border-radius: ${spacing.xs}px;
  color: var(--neutral-white-base);
  padding: ${spacing.sm}px ${spacing.xxl}px;
  margin: 12px 18px;
  text-decoration: none;
  width: fit-content;
  &:hover {
    background-color: var(--brand-bluple-base);
  }
`;
